<template>
  <div ref="container" class="viewport-mount">
    <slot v-if="activated" />
    <slot v-else name="placeholder">
      <div class="viewport-placeholder"><van-loading color="#DD3131" /></div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

const container = ref<HTMLElement>()
const activated = ref(false)
let observer: IntersectionObserver | undefined
onMounted(() => {
  if (!('IntersectionObserver' in window)) {
    activated.value = true
    return
  }
  observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) {
      activated.value = true
      observer?.disconnect()
    }
  }, { rootMargin: '600px 0px' })
  if (container.value) observer.observe(container.value)
})
// Activation is permanent for this instance, including while its tab is hidden.
onBeforeUnmount(() => observer?.disconnect())
</script>

<style scoped lang="scss">
.viewport-placeholder {
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
